const ids = Array.from(Array(3).keys());

export const columns = ids.map(id => ({
    title: `homepage.deIntroduction.column.${id + 1}.title`,
    description: `homepage.deIntroduction.column.${id + 1}.description`,
}));
